module.exports = __webpack_public_path__ + "media/application/images/partners/auswartiges-48ba4b8eaba85b3d27365ff425d58e702d671dbd1084871f6fbacc233028530a.png";